import video from '../components/video';
export default () =>{
    const wrapper = document.querySelector('.news-inner');
    if (!wrapper) return
    const countInitial = wrapper.childElementCount;
    let count
    document.addEventListener('scroll', ()=>{
        count = wrapper.childElementCount;
        count > countInitial?video():false
    });
    
}